module.exports = __webpack_public_path__ + "static/natalie-b468b4adff7de826720cf0020d507e92.png";